import { useSyncExternalStore } from 'react';
import {
  getAnyAgentChatProcessing,
  subscribeAgentChatsProcessing,
} from '@/components/Messenger/cache/agentChatsProcessingStore';

export function useAnyAgentChatProcessing(): boolean {
  return useSyncExternalStore(
    subscribeAgentChatsProcessing,
    getAnyAgentChatProcessing,
    getAnyAgentChatProcessing
  );
}
